import React from 'react'
import { useQuery } from 'react-query'
import { initTransactionForOthers } from 'services/loans'

export default function useSetInitPayment(id: number, amount: number) {
    const { data, isLoading } = useQuery(
        ['init-transaction-for-others', id, amount],
        initTransactionForOthers
    )
    return { data, isLoading }
}
